import { Injectable, inject } from "@angular/core";
import { Subject } from "rxjs";
import { WebglMapLibreService } from "../../services/webgl-maplibre/webgl-maplibre.service";
import { PointInterface, RouteInterface, RouteService } from "../route/route.service";
import { StorageService } from "../storage.service";

@Injectable({
  providedIn: "root",
})
export class RoutesHandlingService {
  private storage = inject(StorageService);
  private mapCtrl = inject(WebglMapLibreService);

  public activeRoute: RouteService;

  private triggers: any[] = [];
  private tempDistance2target: number = 750;

  constructor() {
    this.activeRoute = new RouteService([], ["", ""]);
  }

  public replaceActiveRoute(route: RouteService, addAcftToRoute: boolean): void {
    this.activeRoute = route;
    this.setRouteActive(this.activeRoute.getAllPoints());
  }

  public setMagentaTracklineInvisible() {
    this.mapCtrl.hideNavigRoute = true;
  }

  public setMagentaTracklineVisible() {
    this.mapCtrl.hideNavigRoute = false;
  }

  public newRouteSet = new Subject<PointInterface[]>();
  public setRouteActive(opsCtrlPlannedRoute?: PointInterface[]): void {
    this.activeRoute.cleanRoute();
    const coor = this.activeRoute.getAllPoints();
    this.mapCtrl.drawRoute(coor, opsCtrlPlannedRoute);
    if (coor.length === 0) {
      this.mapCtrl.destinationPos = {
        point: [9, 47],
        valid: false,
      };
    } else {
      this.mapCtrl.destinationPos = {
        point: this.getDest().point,
        valid: true,
      };
    }
    this.newRouteSet.next(opsCtrlPlannedRoute);
  }

  public getDest(): PointInterface {
    const points = this.activeRoute.getAllPoints();
    if (points.length > 0) {
      return points[points.length - 1];
    }

    return {
      point: [0, 0] as [number, number],
      name: "",
      displayName: "",
      id: -1,
      active: false,
    };
  }

  public loadRoute(route: RouteInterface, reverse: boolean): RouteService {
    const points = route.points;
    if (reverse) {
      points.reverse();
    }
    const newRoute = new RouteService(points, route.destination.name);
    newRoute.setId(route.id);
    newRoute.setCreated(route.created);
    return newRoute;
  }

  public getRoutes(): Promise<RouteInterface[]> {
    return new Promise((resolve, reject) => {
      this.storage
        .get("routes")
        .then((res: RouteInterface[]) => {
          console.log(res);

          res.sort((a, b) => {
            const x = a.name.toLowerCase();
            const y = b.name.toLowerCase();
            if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          });
          resolve(res);
        })
        .catch((err) => {
          console.error("err #ssse");
          reject([]);
        });
    });
  }

  public async removeRoute(id: number): Promise<any> {
    try {
      const res: RouteInterface[] = await this.storage.get("routes");

      const index = res.findIndex((route) => route.id === id);
      if (index === -1) {
        throw new Error("Route not found");
      }

      res.splice(index, 1);
      await this.saveRoutes(res);
    } catch (err) {
      console.error("Error in removeRoute: ", err);
      throw err;
    }
  }

  public async addRoute(result: RouteInterface): Promise<any> {
    try {
      let res: RouteInterface[] = await this.storage.get("routes");

      if (!res) {
        res = []; // If no routes are stored, initialize with an empty array
      }

      res.push(result);
      await this.saveRoutes(res);
    } catch (err) {
      console.error("Error in addRoute: ", err);
      throw err;
    }
  }

  public on(event: string, callback: Function) {
    if (!this.triggers[event]) {
      this.triggers[event] = [];
    }
    this.triggers[event].push(callback);
  }

  private triggerHandler(event: string, res: any) {
    if (this.triggers[event]) {
      // eslint-disable-next-line guard-for-in
      for (const i in this.triggers[event]) {
        this.triggers[event][i](res);
      }
    }
  }

  private saveRoutes(result: RouteInterface[]): Promise<any> {
    return new Promise((resolve, reject) => {
      this.storage
        .set("routes", result)
        .then(() => {
          resolve({});
        })
        .catch((err) => {
          console.error("err #asfe");
          reject(err);
        });
    });
  }
}
